import Api from '../Api';

import { url } from './config';
import { PassengerEmail } from './types';

class ExtendedApi extends Api<PassengerEmail> {}

const api = new ExtendedApi(url);

export default api;
